"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AlphaSlider: function() {
        return _AlphaSlider.AlphaSlider;
    },
    ColorArea: function() {
        return _ColorArea.ColorArea;
    },
    ColorPicker: function() {
        return _ColorPicker.ColorPicker;
    },
    ColorSlider: function() {
        return _ColorSlider.ColorSlider;
    },
    alphaSliderClassNames: function() {
        return _AlphaSlider.alphaSliderClassNames;
    },
    colorAreaClassNames: function() {
        return _ColorArea.colorAreaClassNames;
    },
    colorPickerClassNames: function() {
        return _ColorPicker.colorPickerClassNames;
    },
    colorSliderClassNames: function() {
        return _ColorSlider.colorSliderClassNames;
    },
    renderAlphaSlider_unstable: function() {
        return _AlphaSlider.renderAlphaSlider_unstable;
    },
    renderColorArea_unstable: function() {
        return _ColorArea.renderColorArea_unstable;
    },
    renderColorPicker_unstable: function() {
        return _ColorPicker.renderColorPicker_unstable;
    },
    renderColorSlider_unstable: function() {
        return _ColorSlider.renderColorSlider_unstable;
    },
    useAlphaSliderStyles_unstable: function() {
        return _AlphaSlider.useAlphaSliderStyles_unstable;
    },
    useAlphaSlider_unstable: function() {
        return _AlphaSlider.useAlphaSlider_unstable;
    },
    useColorAreaStyles_unstable: function() {
        return _ColorArea.useColorAreaStyles_unstable;
    },
    useColorArea_unstable: function() {
        return _ColorArea.useColorArea_unstable;
    },
    useColorPickerStyles_unstable: function() {
        return _ColorPicker.useColorPickerStyles_unstable;
    },
    useColorPicker_unstable: function() {
        return _ColorPicker.useColorPicker_unstable;
    },
    useColorSliderStyles_unstable: function() {
        return _ColorSlider.useColorSliderStyles_unstable;
    },
    useColorSlider_unstable: function() {
        return _ColorSlider.useColorSlider_unstable;
    }
});
const _ColorSlider = require("./ColorSlider");
const _ColorPicker = require("./ColorPicker");
const _ColorArea = require("./ColorArea");
const _AlphaSlider = require("./AlphaSlider");
